import { render, staticRenderFns } from "./WapAgentAdd.vue?vue&type=template&id=1bb58130&"
import script from "./WapAgentAdd.vue?vue&type=script&lang=js&"
export * from "./WapAgentAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports